<template>
    <section class="container py-12">
        <LoadItemText class="h-8 text-2xl font-bold">
            Loading Product
        </LoadItemText>
        <div class="w-full flex flex-row justify-start items-center gap-3 my-3">
            <LoadItem v-for="(item, index) in 6" :class="'h-8 w-24 rounded-full animation-delay-'" />
        </div>
        <div class="w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 mt-3">
            <LoadProduct v-for="(item, index) in 12" />
        </div>
    </section>
</template>

<script setup lang="ts">
import LoadItemText from "@/Components/Skeleton/LoadItemText.vue";
import LoadProduct from "@/Components/Skeleton/LoadProduct.vue";
import LoadItem from "@/Components/Skeleton/LoadItem.vue";
</script>